// src/modules/appointments/api/appointmentsApi.js
import api from "../../../auth/api";

async function http(method, url, body) {
  const res = await api.request({
    method,
    url,
    data: body,
  });
  const payload = res.data || {};
  if (payload.ok === false) {
    throw new Error(payload.error || "Error en appointments");
  }
  return payload.data ?? payload;
}

/* =============== Listado =============== */
export function getAppointments(params = {}) {
  const q = new URLSearchParams();
  if (params.from) q.append("from", params.from);
  if (params.to) q.append("to", params.to);
  if (params.status) q.append("status", params.status);
  if (params.resource_id) q.append("resource_id", params.resource_id);
  if (params.subject_contact_id)
    q.append("subject_contact_id", params.subject_contact_id);
  if (params.location_id) q.append("location_id", params.location_id);

  const qs = q.toString();
  return http("GET", `/appointment${qs ? `?${qs}` : ""}`);
}

/* =============== Crear / Actualizar =============== */
export function createAppointment(payload) {
  return http("POST", "/appointment", payload);
}

export function updateAppointment(id, payload) {
  return http("PATCH", `/appointment/${id}`, payload);
}

export function getAppointment(id) {
  return http("GET", `/appointment/${id}`);
}

/* =============== Recursos =============== */
export function addAppointmentResource(id, { resource_id, role }) {
  return http("POST", `/appointment/${id}/resources`, { resource_id, role });
}

export function removeAppointmentResource(id, rid) {
  return http("DELETE", `/appointment/${id}/resources/${rid}`);
}

/* =============== Pagos =============== */
export function addAppointmentPayment(id, payload) {
  return http("POST", `/appointment/${id}/payments`, payload);
}

/* =============== Disponibilidad =============== */
export function getAvailability({ resource_id, date }) {
  const q = new URLSearchParams({ resource_id, date });
  return http("GET", `/appointment/availability?${q.toString()}`);
}

export function getAppointmentsConfig() {
  return http("GET", "/config");
}

export function searchContacts({ q = "", limit = 20 } = {}) {
  const params = new URLSearchParams({
    q,
    page: "1",
    limit: String(limit),
  });
  return http("GET", `/contacts?${params.toString()}`).then((data) => ({
    rows: Array.isArray(data?.rows) ? data.rows : [],
    total: data?.total || 0,
  }));
}

export function getContact(id) {
  return http("GET", `/contacts/id/${id}`).then((data) => data.contact || data);
}

export function createContact(payload) {
  return http("POST", "/contacts", payload).then((data) => data.contact || data);
}
